export default [
    {	path: "/changelog/",
		component: () => import("../views/ChangeLog/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
